require('./config.common.js');

var MICROSERVICES_URL = 'https://api.tabulate.com/microservice/';

app
  .constant('API_URL', 'https://api.tabulate.com/zuma-ws/')
  .constant('MICROSERVICES_URL', MICROSERVICES_URL)
  .constant('MICROSERVICES', {
    excel: MICROSERVICES_URL + 'export/excel/',
    pdf: MICROSERVICES_URL + 'export/pdf/'
  })
  .constant('PLAID_ENV', 'development');



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/config/config.prod.js